import { db } from "@/firebaseConfig";

const scheduleMenuGroupCollection = db.collection("schedule_menu_group");

const saveScheduleMenuGroup = async (id, data) => {
  scheduleMenuGroupCollection
    .doc(id)
    .set(data)
    .then(() => {
      console.log("ScheduleMenuGroup successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const updateScheduleMenuGroup = async (id, data) => {
  scheduleMenuGroupCollection
    .doc(id)
    .update(data)
    .then(() => {
      console.log("ScheduleMenuGroup successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const deleteScheduleMenuGroup = async id => {
  scheduleMenuGroupCollection
    .doc(id)
    .delete()
    .then(() => {
      console.log("ScheduleMenuGroup successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const getScheduleMenuGroupById = async id => {
  return scheduleMenuGroupCollection
    .doc(id)
    .get()
    .then(doc => {
      return doc.exists ? doc.data() : null;
    })
    .catch(error => {
      throw error;
    });
};

export {
  scheduleMenuGroupCollection,
  saveScheduleMenuGroup,
  updateScheduleMenuGroup,
  deleteScheduleMenuGroup,
  getScheduleMenuGroupById
};
